<template>
  <a-modal :title="form.id ? '修改角色信息' : '新增角色信息'" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" destroyOnClose :maskClosable="false" width="876px">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="角色名称" prop="role_name">
        <a-input v-model="form.role_name" placeholder="请输入角色名称" />
      </a-form-model-item>
      <a-form-model-item label="手机号脱敏">
        <a-radio-group v-model="form.phone_desensitization">
          <a-radio value="1">
            开启对客户手机号脱敏
          </a-radio>
          <a-radio value="2">
            关闭对客户手机号脱敏
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="微信号脱敏">
        <a-radio-group v-model="form.wechat_desensitization">
          <a-radio value="1">
            开启对客户微信号脱敏
          </a-radio>
          <a-radio value="2">
            关闭对客户微信号脱敏
          </a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="权限授权" required>
        <!-- <a-tree
          v-model="form.menu_power"
          checkable
          auto-expand-parent
          :tree-data="treeData"
          :replaceFields="{ children: 'children', title: 'title', key: 'id' }"
          defaultExpandAll
        /> -->
        <!-- {{ form.menu_power }} -->
        <el-tree ref="tree" size="large" check-strictly :data="treeData" default-expand-all show-checkbox node-key="id"
          v-model="form.menu_power" @check="handleCheck" :props="{
            children: 'children',
            label: 'title'
          }">
          <div class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <div style="padding-left: 20px;" v-if="data.children.length > 0">
              <el-button type="text" size="mini" @click.stop="() => append(node, data)">
                全选
              </el-button>
              <el-button type="text" size="mini" @click.stop="() => remove(node, data)">
                取消全选
              </el-button>
            </div>
          </div>
        </el-tree>
      </a-form-model-item>
      <a-form-model-item label="数据权限">
        <a-select v-model="form.role_type" @change="handleChange">
          <a-select-option value="1"> 查看本部门及以下数据 </a-select-option>
          <!-- <a-select-option value="2"> 只能查看本部门数据 </a-select-option> -->
          <a-select-option value="3"> 只看自己数据 </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="角色状态">
        <a-switch :checked="form.role_status === '1'" @change="changeStatus" />
      </a-form-model-item>
      <a-form-model-item ref="remark" label="备注" prop="remark">
        <a-input v-model="form.remark" placeholder="备注" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import "element-ui/lib/theme-chalk/index.css";
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        role_name: "",
        menu_power: [],
        remark: "",
        role_type: "1", //查看部门类型1查看本部门及以下数据2只能查看本部门数据3只看自己
        role_status: "1", //状态1正常2禁用
        phone_desensitization: '1',
        wechat_desensitization: '1'
      },
      treeData: [],
      groupList: [],
      loadingGroup: false,
      rules: {
        role_name: [
          {
            required: true,
            message: "请输入角色名称",
            trigger: "blur",
          },
          {
            min: 1,
            max: 32,
            message: "输入长度为1-32位",
            trigger: "blur",
          },
        ],
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
  },
  methods: {
    getAllIds(data, ids = []) {
      data.forEach(item => {
        ids.push(item.id);
        if (item.children && item.children.length > 0) {
          this.getAllIds(item.children, ids);
        }
      });
      return ids;
    },
    handleCheck(node, checkedNodes) {
      // 获取所有选中的节点 ID
      this.form.menu_power = checkedNodes.checkedKeys;
    },
    append(node, data) {
      // console.log(node, data)
      const z = this.$refs.tree.getCheckedKeys()
      const a = this.getAllIds([data])
      this.$refs.tree.setCheckedKeys([...z, ...a])
      const b = this.$refs.tree.getCheckedKeys()
      this.form.menu_power = b
    },
    remove(node, data) {
      const z = this.$refs.tree.getCheckedKeys()
      const a = this.getAllIds([data])
      const b = z.filter(item => !a.includes(item));
      this.$refs.tree.setCheckedKeys(b)
      this.form.menu_power = b
    },
    init(id) {
      this.visible = true;
      this.form.id = id;
      if (id) {
        this.$http({
          url: "/admin/role/info",
          method: "post",
          data: {
            id: id,
          },
        }).then((res) => {
          this.form.role_name = res.data.role_name;
          this.form.group_id = res.data.group_id;
          // this.form.menu_power = { checked: res.data.menu_power };
          this.form.menu_power = res.data.menu_power
          this.form.remark = res.data.remark;
          this.form.phone_desensitization = res.data.phone_desensitization
          this.form.wechat_desensitization = res.data.wechat_desensitization
          this.form.role_type = res.data.role_type;
          this.$refs.tree.setCheckedKeys(res.data.menu_power)
        });
      }
      this.getMenuPage();
    },
    changeStatus(bol) {
      this.form.role_status = bol ? "1" : "2";
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const form = {
            ...this.form,
            menu_power: this.form.menu_power
          };
          this.$http({
            url: this.form.id ? "/admin/role/update" : "/admin/role/create",
            method: "post",
            data: form,
          })
            .then(() => {
              this.$message.success(this.form.id ? "修改成功" : "创建成功");
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
    getMenuPage() {
      this.$http({
        url: `/admin/sys/getUserAuthMenu`,
        method: "get",
      }).then((res) => {
        this.treeData = res.data.roleAuthMenu;
      });
    },
    handleChange() {
      this.$refs.group_id.onFieldBlur();
    },
    //集团列表获取成功后
    getGroupDataSuccess(e) {
      if (e.length == 1 && !this.form.role_id) {
        const group_id = e[0].group_id;
        this.form.group_id = group_id;
      }
    },
  },
};
</script>

<style>
.custom-tree-node {
  display: flex;
  width: 100%;
  /* border: 1px solid red; */
}
</style>